
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisorService {
  http = inject(HttpClient);


  public baseUrl: string = environment?.visorBaseUrl;
  private accessWithOptions: any ;
  public refreshData:any;


  constructor(){
    this.accessWithOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'facilityId': '81'
          // 'x-access-code': localStorage.getItem('token'),
        }),
      }
  }

  makeGetRequest(action: any) {
    return this.http.get(this.baseUrl + action, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  makeRequestWithAction(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.message || error))
      );
  }

  public makePostRequest(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error?.error || error))
      );
  }

  makeRequestWithActionError(action: string, params?: any) {
    return this.http.post(this.baseUrl + action, params, this.accessWithOptions.headers)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }


  public downloadImage(action: string): any {
    const accessWithOptions = {
      // headers: new HttpHeaders({
      //   'Content-Type': 'application/octet-stream'
      // }),
      responseType: 'blob' as 'json'
    }
    return this.http.get(this.baseUrl + action, accessWithOptions)
      .pipe(
        map(res => res),
        catchError(error => throwError(error.error || error))
      );
  }

     // drugs search HPI section Treatment Flow
     public drugsSearch(drugTerm : string): Observable<any> {
      if (!drugTerm) {
        return of([]).pipe(delay(500));
      }
      // const action = `drug/getDrugs/${drugTerm}`;
      // const action = `changeHealth/getDrugByName?name=${drugTerm}`;
      const action = `drug/getByName?searchText=${drugTerm}`
      const subItem = this.makeGetRequest(action);
      return subItem;
    }


        // diagnosis track code search from treatment flow
    public diagnosisTrackBy(term?: string ): Observable<any> {
      if (!term) {
        return of([]).pipe(delay(500));
      }
      const action = `diagnosisScore/update/getDiagnosesSearch?searchValue=${term}`;
      const subItem = this.makeGetRequest(action);
      return subItem;
    }


     // diagnosis track by area search from treatment flow
    public diagnosisTrackBybodyArea(term?: string ,bodyArea?:any): Observable<any> {
      if (!term) {
        return of([]).pipe(delay(500));
      }
      const action = `diagnosisScore/update/getDiagnosesSearchForBodyArea?searchValue=${term}&bodyArea=${bodyArea}`;
      const subItem = this.makeGetRequest(action);
      return subItem;
    }

    sendRefresh(data:any){
      this.refreshData = data;
    }

    getRefresh(){
      return this.refreshData;
    }


}